import React from 'react';
import { Box, TextField } from '@mui/material';
import PinIcon from '@mui/icons-material/Pin';
import InputAdornment from '@mui/material/InputAdornment';

export default function PromotionalCode() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
      <TextField
        id="input-with-icon-textfield"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PinIcon />
            </InputAdornment>
          ),
        }}
        placeholder='Código promocional'
        variant="outlined"
      />
    </Box>
  );
}
